export enum Events{
    newMessage
}
